import getEnvConfig from './getEnvConfig';
import { RFI_ENV_CONFIG_KEYS } from '../consts';

export default (env, region, projectId, id) =>
  `${getEnvConfig(
    env,
    region,
    RFI_ENV_CONFIG_KEYS.PJM_FE
  )}/projects/${projectId}/rfis?preview=${id}`;
